import jQuery from 'jquery';

export const initAccordion = () => {
    jQuery(() => {
        const $element = jQuery('.js-accordion');

        if ($element.length) {
            jQuery('.js-accordion > li:first-child').addClass('is-active');
            jQuery('.js-accordion li p').slideUp('fast');
            jQuery('.js-accordion li.is-active p').slideDown('fast');

            jQuery('.js-accordion > li > h5').click(function (event) {
                event.preventDefault();
                jQuery(this).parent('li').toggleClass('is-active').siblings('li')
                    .removeClass('is-active');
                jQuery('.js-accordion li p').slideUp('fast');
                jQuery('.js-accordion li.is-active p').slideDown('fast');
            });
        }
    });
};
